import type { FaireProductEntity } from "../../entity_types/product";

export const p_ykcapkuvqq: FaireProductEntity = {
  token: "p_ykcapkuvqq",
  type: "product",
  name: "Moira 18K Gold Non-Tarnish CZ Statement Ring",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl: "https://cdn.faire.com/fastly/9e556d9a5be05aceeacf6db633c18b7ed590b7dbd95ed56dd2fcd8c2fdef2d8a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6c6cbfc2814d2f842b641e47c305e5cbd3383e2b57bd6a5ee48e6646f8b1771.jpeg",
    "https://cdn.faire.com/fastly/0d055e18c9715421d1d07c14ab919c7c00679714b4ad9ee67578d1dd92aea7f3.jpeg",
    "https://cdn.faire.com/fastly/88dd8e6d91279153dccca2cbb66c18ab412a1e8d46aac436462ecdb5bc8d8a17.jpeg"
  ],
  priceDollars: 6.7,
  description: "18K Gold Non-Tarnish CZ Statement Ring\n18K Gold Plating\nStainless Steel\nCubic Zirconia\nSize 7 Measurement: 0.68 Diameter/2.3 Circumference\n \n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:24.838Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
